export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Спірні колони"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скидання"])}
}